export const offers = [
  {
    title: '3 Hamburguesas',
    description: 'Tres deliciosas hamburguesas con patatas fritas y un litro de Pepsi para compartir.',
    badge: 'OFERTA',
    icon: 'ri-restaurant-line',
    gradient: 'from-[#E63946] to-[#D62839]',
    items: [
      '3 Hamburguesas completas',
      'Patatas fritas grandes',
      '1 Litro de Pepsi'
    ],
    price: '17,00€'
  },
  {
    title: 'Menú Familiar Mixto',
    description: 'La combinación perfecta de kebabs y durums para toda la familia.',
    badge: 'MÁS VENDIDO',
    icon: 'ri-group-line',
    gradient: 'from-gray-800 to-gray-900',
    items: [
      '2 Kebabs completos',
      '2 Durums especiales',
      'Patatas fritas grandes',
      '1 Litro de Pepsi'
    ],
    price: '22,00€'
  },
  {
    title: '3 Platos de Kebab',
    description: 'Tres generosos platos de kebab con patatas y bebida. Ideal para grupos.',
    badge: 'NUEVO',
    icon: 'ri-cake-line',
    gradient: 'from-[#A8DADC] to-[#8BC9CC]',
    items: [
      '3 Platos de Kebab',
      'Patatas incluidas',
      '1 Litro de Pepsi'
    ],
    price: '25,00€'
  },
  {
    title: '4 Durums',
    description: 'Cuatro durums especiales con patatas fritas y bebida para compartir.',
    badge: 'OFERTA',
    icon: 'ri-restaurant-line',
    gradient: 'from-[#E63946] to-[#D62839]',
    items: [
      '4 Durums especiales',
      'Patatas fritas grandes',
      '1 Litro de Pepsi'
    ],
    price: '25,00€'
  },
  {
    title: 'Box Kebab',
    description: 'Kebab individual con patatas fritas. Perfecto para una comida rápida.',
    badge: 'ECONÓMICO',
    icon: 'ri-takeaway-line',
    gradient: 'from-gray-800 to-gray-900',
    items: [
      '1 Kebab completo',
      'Patatas fritas'
    ],
    price: '6,00€'
  }
];
